import {
  faEnvelope,
  faInfo,
  faClipboard,
  faListCheck,
  faRightFromBracket,
  faGlobe,
  faFastForward,
  faForward,
  faBackward,
  faCheck,
  faCheckSquare,
  faCheckCircle,
  faPlus,
  faMinus,
  faEdit,
  faUpload,
  faSquare,
  faLock,
  faLockOpen,
  faCog,
  faTimesCircle,
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faChevronUp,
  faChevronCircleDown,
  faChevronCircleUp,
  faChevronCircleRight,
  faChevronCircleLeft,
  faQuestion,
  faQuestionCircle,
  faCalendar,
  faCalendarDays,
  faCalendarWeek,
  faBuilding,
  faTimes,
  faComments,
  faEye,
  faEyeSlash,
  faExclamation,
  faSearch,
  faSort,
  faExclamationCircle,
  faPen,
  faTrash,
  faFolderTree,
  faTrashAlt,
  faUser,
  faUserPlus,
  faUserMinus,
  faUserEdit,
  faUserCheck,
  faUserTimes,
  faTree,
  faCrosshairs,
  faAngleDown,
  faAngleUp,
  faAngleRight,
  faAngleLeft,
  faPlusCircle,
  faMinusCircle,
  faWrench,
  faFileExcel,
  faDownload,
  faVectorSquare,
  faDrawPolygon,
  faFolderOpen,
  faFolder,
  faLinesLeaning,
  faFolderPlus,
  faCaretUp,
  faInfoCircle,
  faFileImport,
  faBinoculars,
  faSync,
  faSyncAlt,
  faExpand,
  faExpandAlt,
  faSave,
  faArrowsAlt,
  faArrowsDownToLine,
  faMapMarker,
  faMinusSquare,
  faCaretDown,
  faUserTag,
  faList,
  faSignInAlt,
  faArrowAltCircleUp,
  faArrowCircleDown,
  faPenNib,
  faUnlockAlt,
  faExpandArrowsAlt,
  faFilter,
  faFilePdf,
  faPlusSquare,
  faExternalLinkAlt,
  faSearchMinus,
  faUserFriends,
  faPaperclip,
  faSearchPlus,
  faAlignCenter,
  faAlignJustify,
  faAlignLeft,
  faAlignRight,
  faLocationCrosshairs,
  faMessage,
  faFile,
  faTableList,
  faMinimize,
  faMaximize,
  faWindowMinimize,
  faWindowRestore,
  faMarker,
  faStarHalfStroke,
  faRightLeft
  
} from '@fortawesome/free-solid-svg-icons';

import { library } from '@fortawesome/fontawesome-svg-core';

library.add(
  faEnvelope,
  faMarker,
  faInfo,
  faTableList,
    faMaximize,
    faStarHalfStroke,
    faRightLeft,
  faWindowMinimize,
  faWindowRestore,
  faClipboard,
  faListCheck,
  faMinimize,
  faRightFromBracket,
  faGlobe,
  faFastForward,
  faForward,
  faBackward,
  faFolderTree,
  faCheck,
  faCheckSquare,
  faCheckCircle,
  faPlus,
  faMinus,
  faEdit,
  faUpload,
  faSquare,
  faFile,
  faLock,
  faLockOpen,
  faCog,
  faTimesCircle,
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faChevronUp,
  faChevronCircleDown,
  faChevronCircleUp,
  faChevronCircleRight,
  faChevronCircleLeft,
  faQuestion,
  faQuestionCircle,
  faCalendar,
  faCalendarDays,
  faCalendarWeek,
  faBuilding,
  faTimes,
  faComments,
  faEye,
  faExclamation,
  faSearch,
  faSort,
  faExclamationCircle,
  faPen,
  faTrash,
  faTrashAlt,
  faUser,
  faUserPlus,
  faUserMinus,
  faUserEdit,
  faUserCheck,
  faUserTimes,
  faTree,
  faCrosshairs,
  faPlusCircle,
  faMinusCircle,
  faAngleDown,
  faAngleUp,
  faAngleRight,
  faAngleLeft,
  faWrench,
  faFileExcel,
  faDownload,
  faVectorSquare,
  faDrawPolygon,
  faFolderOpen,
  faFolder,
  faLinesLeaning,
  faFolderPlus,
  faCaretUp,
  faInfoCircle,
  faFileImport,
  faBinoculars,
  faSync,
  faExpand,
  faExpandAlt,
  faSave,
  faArrowsAlt,
  faArrowsDownToLine,
  faMapMarker,
  faMinusSquare,
  faCaretDown,
  faUserTag,
  faList,
  faSignInAlt,
  faArrowAltCircleUp,
  faArrowCircleDown,
  faPenNib,
  faUnlockAlt,
  faExpandArrowsAlt,
  faFilter,
  faFilePdf,
  faPlusSquare,
  faExternalLinkAlt,
  faSearchMinus,
  faUserFriends,
  faPaperclip,
  faSearchPlus,
  faAlignCenter,
  faAlignJustify,
  faAlignLeft,
  faAlignRight,
  faSyncAlt,
  faEyeSlash,
  faLocationCrosshairs,
  faMessage
);

export default library;
